/**
 * Valide la force d'un mot de passe
 * @param {string} password - Le mot de passe à valider
 * @returns {object} - Objet contenant isValid et errors
 */
export const validatePasswordStrength = (password) => {
  const errors = [];
  
  // Minimum 8 caractères
  if (password.length < 8) {
    errors.push('Au moins 8 caractères');
  }
  
  // Au moins une majuscule
  if (!/[A-Z]/.test(password)) {
    errors.push('Au moins une lettre majuscule');
  }
  
  // Au moins une minuscule
  if (!/[a-z]/.test(password)) {
    errors.push('Au moins une lettre minuscule');
  }
  
  // Au moins un chiffre
  if (!/[0-9]/.test(password)) {
    errors.push('Au moins un chiffre');
  }
  
  // Au moins un caractère spécial
  if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) {
    errors.push('Au moins un caractère spécial (!@#$%^&*...)');
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
};

/**
 * Calcule le score de force du mot de passe (0-100)
 * @param {string} password - Le mot de passe
 * @returns {number} - Score entre 0 et 100
 */
export const getPasswordStrength = (password) => {
  let strength = 0;
  
  if (password.length >= 8) strength += 20;
  if (password.length >= 12) strength += 10;
  if (/[a-z]/.test(password)) strength += 15;
  if (/[A-Z]/.test(password)) strength += 15;
  if (/[0-9]/.test(password)) strength += 15;
  if (/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) strength += 25;
  
  return Math.min(strength, 100);
};

/**
 * Retourne la couleur correspondant à la force du mot de passe
 * @param {number} strength - Score de force (0-100)
 * @returns {string} - Couleur hex
 */
export const getStrengthColor = (strength) => {
  if (strength < 40) return '#FF5722'; // Rouge - Faible
  if (strength < 70) return '#FF9800'; // Orange - Moyen
  return '#4CAF50'; // Vert - Fort
};

/**
 * Retourne le label correspondant à la force du mot de passe
 * @param {number} strength - Score de force (0-100)
 * @returns {string} - Label
 */
export const getStrengthLabel = (strength) => {
  if (strength === 0) return '';
  if (strength < 40) return 'Faible';
  if (strength < 70) return 'Moyen';
  return 'Fort';
};



